import { $_WC } from "@/confs/common.const";

export default {
    // 미세먼지 등급
    pm10Level(val) {
        if(typeof val === $_WC.UNDEF) {
            return ['checking', '점검중', 0, '#797f82', 't_gray'];
        }
        if(val >= 151) {
            return ['worse', '매우나쁨', 10, '#e57373', 't_red'];
        } else if(val >= 81 && val <= 150) {
            return ['bad', '나쁨', 20, '#e0bc24', 't_yellow'];
        } else if(val >= 31 && val <= 80) {
            return ['normal', '보통', 90, '#92dd92', 't_green'];
        } else if(val >= 0 && val <= 30) {
            return ['good', '좋음', 100, '#91defa', 't_blue'];
        } else {
            return ['checking', '점검중', 0, '#797f82', 't_gray'];
        }
    },

    // 초 미세먼지 등급
    pm25Level(val) {
        if(typeof val === $_WC.UNDEF) {
            return ['checking', '점검중', 0, '#797f82', 't_gray'];
        }
        if(val >= 76) {
            return ['worse', '매우나쁨', 10, '#e57373', 't_red'];
        } else if(val >= 36 && val <= 75) {
            return ['bad', '나쁨', 20, '#e0bc24', 't_yellow'];
        } else if(val >= 16 && val <= 35) {
            return ['normal', '보통', 90, '#92dd92', 't_green'];
        } else if(val >= 0 && val <= 15) {
            return ['good', '좋음', 100, '#91defa', 't_blue'];
        } else {
            return ['checking', '점검중', 0, '#797f82', 't_gray'];
        }
    },

    // 이산화질소 등급
    no2Level(val) {
        if(typeof val === $_WC.UNDEF) {
            return ['checking', '-', 0];
        }

        if(val >= 0.201) {
            return ['worse', '매우나쁨', 10, '#e57373', 't_red'];
        } else if(val >= 0.061 && val <= 0.200) {
            return ['bad', '나쁨', 20, '#e0bc24', 't_yellow'];
        } else if(val >= 0.031 && val <= 0.060) {
            return ['normal', '보통', 90, '#92dd92', 't_green'];
        } else if(val >= 0 && val <= 0.030) {
            return ['good', '좋음', 100, '#91defa', 't_blue'];
        } else {
            return ['checking', '점검중', 0, '#797f82', 't_gray'];
        }
    },

    // 오존 질소 등급
    o3Level(val) {
        if(typeof val === $_WC.UNDEF) {
            return ['checking', '-', 0];
        }

        if(val >= 0.151) {
            return ['worse', '매우나쁨', 10, '#e57373', 't_red'];
        } else if(val >= 0.091 && val <= 0.150) {
            return ['bad', '나쁨', 20, '#e0bc24', 't_yellow'];
        } else if(val >= 0.031 && val <= 0.090) {
            return ['normal', '보통', 90, '#92dd92', 't_green'];
        } else if(val >= 0 && val <= 0.030) {
            return ['good', '좋음', 100, '#91defa', 't_blue'];
        } else {
            return ['checking', '점검중',0, '#797f82', 't_gray'];
        }
    },

    // 대기 등급에 따른 색상
    getAirQaColor(grade) {
        let colorObj = {
            good: 'rgb(35,153,253)',
            normal: 'rgb(125,220,30)',
            bad: 'rgb(254,126,0)',
            worse: 'rgb(249,41,39)',
            checking: 'rgb(144,142,143)',
        }

        let color = colorObj[grade];

        if(typeof color !== 'undefined') {
            return color;
        } else {
            return "#96989B";
        }
    },
    decibelLevel(val) {
        if(val == undefined || isNaN(val) || val == '') {
            return ['checking', '점검중', '점검중', '#797f82', 't_gray'];
        }
        val = Number(val);
        let valNum = val.toFixed(0);
        if(valNum > 70) {
            return ['worse', '최악', valNum, '#e57373', 't_red'];
        } else if(valNum > 60 && valNum <= 70) {
            return ['bad', '나쁨', valNum, '#e0bc24', 't_yellow'];
        } else if(valNum > 50 && valNum <= 60) {
            return ['normal', '보통', valNum, '#92dd92', 't_green'];
        } else if(valNum >= 0 && valNum <= 50) {
            return ['good', '좋음', valNum, '#91defa', 't_blue'];
        } else {
            return ['checking', '점검중', '점검중', '#797f82', 't_gray'];
        }
    },
    rainfallLevel(val) {
        if(val === undefined || isNaN(val) || val === '') {
            return ['checking', '점검중', '점검중', '#797f82', 't_gray'];
        }
        let valNum = Number(val);

        if(valNum >= 90) {
            return ['worse', '경보', valNum, '#e57373', 't_red'];
        } else if(valNum >= 60 && valNum < 90) {
            return ['bad', '주의', valNum, '#e0bc24', 't_yellow'];
        } else if(valNum >= 0 && valNum < 60) {
            return ['normal', '보통', valNum, '#92dd92', 't_green'];
        } else {
            return ['checking', '점검중', '점검중', '#797f82', 't_gray'];
        }
    },
    waterLevel(val, limit) {
        if(val === undefined || isNaN(val) || val === '' || limit === undefined || isNaN(limit) || limit === '') {
            return ['checking', '점검중', '점검중', '#797f82', 't_gray'];
        }
        let valNum = Number(val);
        let limitNum = Number(limit);

        if(valNum >= limitNum) {
            return ['worse', '경보', valNum, '#e57373', 't_red'];
        } else if(valNum < limitNum) {
            return ['normal', '보통', valNum, '#92dd92', 't_green'];
        } else {
            return ['checking', '점검중', '점검중', '#797f82', 't_gray'];
        }
    },
    waterQuality(val, waterCode){
        if(val === undefined || isNaN(val) || val === '') {
            return ['checking', '점검중', '점검중', '#797f82'];
        }
        val = Number(val);
        let waterQuality = ['good', '정상','', '#91defa'];
        if(typeof waterCode !== 'undefined') {
            if(waterCode === 'val7' && val > 8.5){
                waterQuality = ['bad','수질이상','red', '#e57373'];
            }else if(waterCode === 'val8' && val > 4){
                waterQuality = ['bad','수질이상','red', '#e57373'];
            }else if(waterCode === 'val9' && val > 0.5){
                waterQuality = ['bad','수질이상','red', '#e57373'];
            }
        }
        return waterQuality;
    },
    waterAllQuality(waterInfo){
        let waterQuality = ['good', '정상',''];
        if(Number(waterInfo.val7) > 8.5 || Number(waterInfo.val8) > 4 || Number(waterInfo.val9) > 0.5){
            waterQuality = ['bad','수질이상','red'];
        }
        return waterQuality;
    }
}
